import mob_layer from '../leafmob/mob-layer'

const leaf_grid_layer = {
	create: mob_layer.create
};

export default leaf_grid_layer;